import styled from "styled-components";

export const SubjectsIntroContainer = styled.div`
	.subjectsintro_main {
		padding: 80px 0;
		padding-bottom: 20px;
	}

	.subjects_intro_heading {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		padding-right: 20px;
	}

	.subjects_intro_text {
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100%;
	}

	.subheading {
		font-size: 1.1rem;
		color: #6c757d;
		margin-bottom: 15px;
		text-transform: uppercase;
		letter-spacing: 2px;
	}

	.subjects-intro_subtxt {
		font-size: 1.8rem;
		margin: 20px 0 30px 0;
		color: #2c3e50;
		line-height: 1.4;
	}

	.redfont {
		color: #e74c3c;
	}

	p {
		font-size: 1.1rem;
		line-height: 1.7;
		color: #555;
		margin-bottom: 20px;
	}

	.subjects_intro_text p strong {
		color: #e74c3c;
		font-weight: bold;
	}

	.subjects_intro_images {
		display: flex;
		flex-direction: row;
		gap: 30px;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.mygrid-row {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.subjects_intro_image_wrapper {
		width: 150px;
		height: 82px;
		padding: 10px;
		border-top-right-radius: 20px;
		border-bottom-left-radius: 20px;
		background: white;
		box-shadow: 0px 4px 10px 0px #00000040;
		opacity: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: background-color 0.3s ease;

		&:hover {
			background: #ffe9d5cc;
			cursor: pointer;
		}
	}

	.subjects_intro_image_wrapper img {
		width: 90px;
		height: 40px;
		object-fit: contain;
	}

	.video_section_founder {
		padding: 60px 0;
		background: white;
	}

	/* Subject Cards Section */
	.subjects_cards_section {
		padding: 60px 0;
		background: white;
	}

	.subjects_cards_wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.subjects_cards_grid {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		gap: 20px;
		max-width: 100%;
	}

	.subject_card {
		background: white;
		border-radius: 12px;
		padding: 20px 15px;
		text-align: center;
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease, box-shadow 0.3s ease;
		cursor: pointer;
		min-width: 150px;
		border: 2px solid transparent;

		&:hover {
			transform: translateY(-5px);
			box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
			border-color: #e74c3c;
		}
	}

	.subject_name {
		font-size: 1.2rem;
		font-weight: bold;
		color: #2c3e50;
		margin-bottom: 8px;
		letter-spacing: 1px;
		line-height: 1.2;
	}

	.subject_icon {
		font-size: 1.4rem;
		display: inline-block;
	}

	.master_text {
		font-size: 0.8rem;
		color: #bdc3c7;
		font-weight: 500;
		letter-spacing: 2px;
		text-transform: uppercase;
	}

	.subjectsintro_main  .subjects_intro_images {
		margin-top: 50px;
	}

	@media (max-width: 991px) {
		.subjectsintro_main .mygrid-col-lg-4.mygrid-col-md-12 {
			width: 100%;
		}
	}

	@media (max-width: 991px) {
		.subjectsintro_main {
			padding: 60px 0;
			padding-bottom: 0px;
		}

		.subjects_intro_heading {
			padding-right: 0;
			margin-bottom: 10px;
		}

		.subjects_intro_text {
			padding-left: 0;
		}

		.subjects-intro_subtxt {
			font-size: 1.5rem;
		}

		p {
			font-size: 1rem;
		}

		.subjects_intro_images {
			gap: 20px;
		}

		.subjects_intro_image_wrapper {
			width: 120px;
			height: 65px;
			padding: 8px;
		}

		.subjects_intro_image_wrapper img {
			width: 70px;
			height: 30px;
		}
		.subjectsintro_main .subjects_intro_images {
			margin-top: 20px;
		}

	}
`;
